import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { NewsletterForm } from "./Footer";

export const EmailCapturePopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("shodan_popup_seen")) return;
    const t = setTimeout(() => setOpen(true), 9000);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => { localStorage.setItem("shodan_popup_seen", "1"); setOpen(false); };

  if (!open) return null;
  return (
    <div className="fixed bottom-4 right-4 z-[65] w-full max-w-md pl-4 sm:pl-0">
      <div data-testid="email-capture-popup" className="relative bg-[#121212] text-white p-8 border border-white/10 shadow-2xl">
        <button data-testid="popup-close-btn" onClick={dismiss} aria-label="Close" className="absolute top-4 right-4 text-white/50 hover:text-white"><X size={18} /></button>
        <div className="flex items-center gap-3 mb-4" data-testid="popup-brand-header">
          <img src="/logo.png" alt="Shodan Security logo" className="h-10 w-10 object-contain" />
          <span className="font-heading font-black text-xl tracking-tighter uppercase">Shodan <span className="text-[#8FA84E]">Security</span></span>
        </div>
        <h3 className="font-heading font-black text-2xl uppercase tracking-tighter mt-3 leading-tight">Get 10% Off Your First Order</h3>
        <p className="text-white/60 text-sm mt-2">Join the Shodan Security list and get the free <span className="text-white font-bold">Preparedness Checklist</span> plus code <span className="text-white font-bold font-mono">WELCOME10</span> instantly.</p>
        <div className="mt-5">
          <NewsletterForm source="popup" dark onSuccess={() => { localStorage.setItem("shodan_popup_seen", "1"); setTimeout(() => setOpen(false), 15000); }} />
        </div>
        <button onClick={dismiss} className="mt-4 text-[11px] uppercase tracking-widest font-bold text-white/40 hover:text-white/70">No thanks, I'm already prepared</button>
      </div>
    </div>
  );
};
